import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=9c7e6d4a&"
import script from "./Comparison.vue?vue&type=script&lang=js&"
export * from "./Comparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductM1EcuTable: require('/usr/src/motec/components/product/M1Ecu/Table.vue').default})
